export const RMA_TEMPORARY_FILE_UPLOADED = 'csc-rma-temporary-file-uploaded' as const
export const RMA_TEMPORARY_FILE_REMOVED = 'csc-rma-temporary-file-removed' as const
